//--------------- IMPORTAÇÕES ---------------//
import { UsuariosContext } from "../context/UsuariosContext";
import { useContext } from "react";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerCreateCompany() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const {formData, setFormData} = useContext(UsuariosContext);
    const {isEditing, setIsEditing} = useContext(UsuariosContext);
    const {userIdEdited, setUserIdEdited} = useContext(UsuariosContext);
    const {passwordOnly, setPasswordOnly} = useContext(UsuariosContext);
    const {isModalOpen, setIsModalOpen} = useContext(UsuariosContext);

    

    //-------------- FUNÇÃO ABRIR MODAL --------------//
    function handleOpenModal (usuario = null, apenasSenha = false) {
        if (usuario) {
            setFormData({
                nome: usuario.nome,
                email: usuario.email,
                senha: ""
            });
            setIsEditing(true);
            setUserIdEdited(usuario.id);
            setPasswordOnly(apenasSenha);
        } else {
            setFormData({
                nome: "",
                email: "",
                senha: ""
            });
            setIsEditing(false);
            setUserIdEdited(null);
            setPasswordOnly(false);
        }
        setIsModalOpen(true);
    };



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* BUTTON ADICIONAR NOVO USUÁRIO */}
            <button
                onClick={() => handleOpenModal()}
                className="mb-4 bg-brand-600 hover:bg-brand-700 px-4 py-2 rounded h-[40px] w-full sm:max-w-[250px]"
            >
                Novo Usuário
            </button>

        </>
    )
}